import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import * as OrderDetailActions from '../orders/order-details/orders.details.actions';
import * as ShipmentDetailActions from '../shipments/shipment-details/shipments.details.actions';
import { LogService } from '../../services/log-service';

export const logFailureEpicsToSenty = (action$) => {
  return action$.pipe(
    ofType(OrderDetailActions.GET_ORDER_DETAILS_FAILURE, ShipmentDetailActions.GET_SHIPMENT_DETAILS_FAILURE),
    mergeMap((action) => {
      const { error } = action;
      LogService.logError(error, action);
      return EMPTY;
    }),
  );
};
